import { render, staticRenderFns } from "./FundsOrderDetails.vue?vue&type=template&id=3605f9bc&scoped=true&"
import script from "./FundsOrderDetails.vue?vue&type=script&lang=ts&"
export * from "./FundsOrderDetails.vue?vue&type=script&lang=ts&"
import style0 from "./FundsOrderDetails.vue?vue&type=style&index=0&id=3605f9bc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3605f9bc",
  null
  
)

export default component.exports